import { ROUTES } from '@/utils/routes';

type CourseLessonsHrefParams = {
  slug?: string;
  klassId?: number;
};

export const getCourseLessonsHref = ({
  slug,
  klassId,
}: CourseLessonsHrefParams) =>
  slug ? ROUTES.COURSES.INFO(slug, klassId) : ROUTES.COURSES.BASE;
